import { render, staticRenderFns } from "./StartEndTransferList.vue?vue&type=template&id=37abc29a"
import script from "./StartEndTransferList.vue?vue&type=script&lang=js"
export * from "./StartEndTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports